import {
  LIST_USERS_RESPONSE,
} from '../constants'

// query -> [user_id]
const initialState = {}

export default function update(state = initialState, action) {
  switch (action.type) {
    case LIST_USERS_RESPONSE: {
      const s = { ...state }
      const users = action.users || []
      s[action.query] = users.map((user) => (user.user_id))
      return s
    }
    default:
      return state
  }
}
